(function () {
  function initOne(root) {
    if (root.dataset.heroInit) return;
    root.dataset.heroInit = '1';
    var viewport = root.querySelector('.hhero__viewport');
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.hhero__slide');
    var total = slides.length;
    if (total < 1) return;
    var countLabels = root.querySelectorAll('[data-count-label]');
    var pills = root.querySelectorAll('[data-goto]');
    var index = 0;

    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
    function setHeight() {
      if (isMobile()) { viewport.style.height = slides[index].offsetHeight + 'px'; }
      else { viewport.style.height = ''; }
    }
    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < countLabels.length; i++) { countLabels[i].textContent = (index + 1) + ' / ' + total; }
      for (var c = 0; c < pills.length; c++) { pills[c].classList.toggle('is-active', c === index); pills[c].setAttribute('aria-selected', c === index ? 'true' : 'false'); }
      setHeight();
    }
    function go(i) { index = (i % total + total) % total; render(); }

    var prevs = root.querySelectorAll('[data-prev]');
    var nexts = root.querySelectorAll('[data-next]');
    for (var p = 0; p < prevs.length; p++) prevs[p].addEventListener('click', function () { go(index - 1); });
    for (var n = 0; n < nexts.length; n++) nexts[n].addEventListener('click', function () { go(index + 1); });
    for (var g = 0; g < pills.length; g++) { (function (el) { el.addEventListener('click', function () { go(parseInt(el.getAttribute('data-goto'), 10) || 0); }); })(pills[g]); }

    window.addEventListener('resize', setHeight);
    window.addEventListener('load', setHeight);
    // re-measure after images load
    var imgs = track.querySelectorAll('img');
    for (var k = 0; k < imgs.length; k++) {
      if (!imgs[k].complete) imgs[k].addEventListener('load', setHeight);
    }
    render();
  }
  function initAll() {
    var nodes = document.querySelectorAll('[data-hero]');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
